
// export default Home;
import React, { useRef } from "react";
import { MDBBtn } from 'mdb-react-ui-kit';
import {
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBRow,
  MDBCol,
  MDBRipple,
} from "mdb-react-ui-kit";
import smartreportBanner from "../images/Technology/Patient_eligibility_verificaition.webp";
import smartreportBanner1 from "../img/technologies/Infographic/Patient eligibility verificaition.png"
import comunicate from "../img/in network out of network.svg";
import digitalpayment from "../img/procedure pre authorization.svg";
import textreminder from "../img/patient financial.svg";
import "../css/splitsetnew1.css";
import "../css/servicesfont.css";
const Home = () => {
  const ref = useRef(null);
  const ref1 = useRef(null);
  const ref2 = useRef(null);

  const handleClick = () => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  };
  const handleClick1 = () => {
    ref1.current?.scrollIntoView({ behavior: 'smooth' });
  };
  const handleClick2 = () => {
    ref2.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <MDBContainer fluid className="bg-light p-0">
      <div className="container py-5">

        <div className="button-overlay2 mt-4 mb-4 d-none d-lg-block" style={{ paddingLeft: '120px' }}>
          <img
            className=""
            src={smartreportBanner}
            alt="Patient Eligibility Insurance Verification"

            style={{ borderRadius: "10px", width: '100%' }}
          />
          <MDBBtn color='link' rippleColor='dark' onClick={handleClick} style={{ fontSize: '14px', color: 'white', fontFamily: 'Alegreya Sans', fontWeight: 'bold', backgroundColor: 'transparent', marginTop: '147px' }} className="button-overlay2 button">
          </MDBBtn>
          <MDBBtn color='link' rippleColor='dark' onClick={handleClick1} style={{ fontSize: '14px', color: 'black', width: '365px', marginTop: '765px', height: '85px', left: '82%', fontFamily: 'Alegreya Sans', fontWeight: 'bold', backgroundColor: 'transparent' }}>
          </MDBBtn>
          <MDBBtn color='link' rippleColor='dark' onClick={handleClick2} style={{ fontSize: '14px', color: 'black', marginTop: '455px', width: '365px', left: '82%', height: '85px', fontFamily: 'Alegreya Sans', fontWeight: 'bold', backgroundColor: 'transparent' }}>
          </MDBBtn>
          <MDBBtn color='link' rippleColor='dark' style={{ fontSize: '14px', color: 'black', marginTop: '430px', width: '250px', left: '31%', height: '200px', fontFamily: 'Alegreya Sans', backgroundColor: 'transparent' }}>
          </MDBBtn>
        </div>

        <div className="button-overlay2 mt-4 mb-4 d-lg-none">
          <img
            className=""
            src={smartreportBanner1}
            alt="Patient Eligibility Insurance Verification"
            style={{ borderRadius: "10px", width: '100%' }}
          />
        </div>

        <div ref={ref} className="card mt-4">
          <div className="row">
            {/* <div className="col-lg-12 mb-5 p-4 d-md-none"> */}
              {/* <div className="row">
                <div class="col-md-8" style={{ marginTop: '100px' }}>
                  <h2 className="title AcerhealthTextPurple  text-center fontsizeset2" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>In-Network/Out of Network Patient Eligibility and Benefits Verification</h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p className="mt-3 mb-0 justify-content-left" style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>
                    Most of the patients are not entitled to out of network advantages. This leads to a major loss for the provider even after rendering the standard service. AcerHealth overcomes this drawback by often pursuing benefits verification for all the patients. We complete the patient benefits verification 2 days prior to the date of service. Some of the vital information we gather includes type of plan, covered services, out-of-pocket services, copays and coordination of benefits.
                  </p>
                </div>
                <div class="col-md-4 text-center mt-4">
                  <img src={comunicate} className="img-fluid" width={350} height={250} alt="Patient Eligibility" />
                </div>
              </div>
            </div> */}
            <div className="col-lg-12 mb-5 p-4 d-none d-md-block">
              <div className="row">
                <div class="col-md-4 text-center mt-4">
                  <img src={comunicate} className="img-fluid" width={350} height={250} alt="Patient Eligibility" />
                </div>
                <div class="col-md-8" style={{ marginTop: '100px' }}>
                  <h2 className="title AcerhealthTextPurple  text-center fontsizeset2" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>In-Network/Out of Network Patient Eligibility and Benefits Verification</h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p className="mt-3 mb-0 justify-content-left" style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500',textAlign: 'justify' }}>
                   Most patients are not entitled to out-of-network benefits, which can result in significant revenue loss for providers even after delivering standard care.
                   <b> AcerHealth </b>addresses this challenge through comprehensive <b>patient eligibility and benefits verification</b> for every patient, ensuring clarity and reducing 
                    risk. Our team completes this verification two days prior to the date of service, gathering vital information such as plan type, covered and out-of-pocket 
                    services, copays, and coordination of benefits. This process strengthens 
                     <a
                            href="https://acerhealth.com/services/revenue-cycle-management"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
               revenue cycle management,
                        </a>  
                    supports efficient <b>medical billing services,</b> and enhances 
                    the reliability of your medical billing outsourcing efforts—helping your practice reduce denials and secure predictable reimbursements.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div ref={ref1} className="card p-4 mt-4">
          <div className="row">
            <div className="col-lg-12 mb-5">
              <div className="row">
                <div class="col-md-8" style={{ marginTop: '100px' }}>
                  <h2 className="title AcerhealthTextPurple  text-center fontsizeset2" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>
                    Procedure Pre-Authorization</h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p className="mt-3 mb-0 justify-content-left" style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: 'justify' }}>
                  Securing insurance pre-authorization for procedures or medications can be a time-consuming and costly process that distracts providers
                   from delivering quality patient care. To help overcome this challenge, <b>AcerHealth </b>offers in-house <b>procedure pre-authorization </b>services that 
                   reduce the administrative burden on your practice. Our team completes authorizations for all patients and reports the authorization details to 
                   you five days prior to the date of service. This streamlined process enhances efficiency, supports <b>revenue cycle management, </b>strengthens <b>medical
                    billing services,</b> and improves the performance of your medical billing outsourcing strategy—helping you focus on patient care while ensuring 
                    compliance and faster reimbursements.
                  </p>
                </div>
                <div class="col-md-4 text-center ">
                  <img src={digitalpayment} className="img-fluid" width={350} height={250} alt="Procedure pre Authorization" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div ref={ref2} className="card p-4 mt-4">
          <div className="row">
            {/* <div className="col-lg-12 mb-5 d-md-none">
              <div className="row">
                <div class="col-md-8" style={{ marginTop: '100px' }}>
                  <h2 className="title AcerhealthTextPurple  text-center fontsizeset2" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>
                    Patient Financial Responsibility Verification</h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p className="mt-3 mb-0 justify-content-left" style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>
                    We assist you to control your patient receivables by generating and sharing patient liability reports often.
                    This methodology helps us track and study outstanding balances and helps your center push for unfinished balances
                    from the patients at the time of the next appointment. This practice controls the amount the patient owed and keeps the account clean.
                  </p>
                </div>
                <div class="col-md-4 text-center ">
                  <img src={textreminder} className="img-fluid" width={350} height={250} alt="patient financial Responsibilty verification" />
                </div>

              </div>
            </div> */}
            <div className="col-lg-12 mb-5 d-none d-md-block">
              <div className="row">
                <div class="col-md-4 text-center ">
                  <img src={textreminder} className="img-fluid" width={350} height={250} alt="patient financial Responsibilty verification" />
                </div>
                <div class="col-md-8" style={{ marginTop: '100px' }}>
                  <h2 className="title AcerhealthTextPurple  text-center fontsizeset2" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>
                    Patient Financial Responsibility Verification</h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p className="mt-3 mb-0 justify-content-left" style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' ,textAlign: 'justify'}}>
                    We help your practice control patient receivables by regularly generating and sharing detailed <b>patient liability reports.</b> 
                    This approach allows you to track and analyze outstanding balances, making it easier to follow up and collect any pending 
                    amounts during the patient’s next appointment. By proactively addressing patient financial responsibility, your center can 
                    maintain cleaner accounts, reduce bad debt risk, and improve overall collections. This process directly supports stronger
                     <a
                            href="https://acerhealth.com/services/revenue-cycle-management"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
             revenue cycle management,
                        </a>  
                     enhances <b>medical billing services,</b> and boosts the efficiency of your medical billing outsourcing strategy—ensuring
                     healthier cash flow and better financial control.
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </MDBContainer>
  );
};

export default Home;
